export type ReactSVGIconProps = {
  tag: string;
  attr?: React.SVGAttributes<SVGElement> & {
    'fill-rule'?: string
    'clip-rule'?: string
    'styles'?: string
  };
  child?: ReactSVGIconProps[];
};
export const GoTaskListIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor'},
  'child': [{
    'tag': 'path',
    'attr': {'d': 'M3 6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm1.5 4.5h4v-4h-4Zm8.25-5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm0 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm-2.97-2.53a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 2.97-2.97a.75.75 0 0 1 1.06 0Z'},
    'child': []
  }]
}

export const PiCalendarXIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 256 256', 'fill': 'currentColor'},
  'child': [{
    'tag': 'path',
    'attr': {'d': 'M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-50.34-74.34L139.31,152l18.35,18.34a8,8,0,0,1-11.32,11.32L128,163.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L116.69,152,98.34,133.66a8,8,0,0,1,11.32-11.32L128,140.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z'},
    'child': []
  }]
}

export const LiaCommentsSolidIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 32 32', fill: 'currentColor'},
  'child': [{
    'tag': 'path',
    'attr': {'d': 'M 2 5 L 2 21 L 6 21 L 6 26.09375 L 7.625 24.78125 L 12.34375 21 L 22 21 L 22 5 Z M 4 7 L 20 7 L 20 19 L 11.65625 19 L 11.375 19.21875 L 8 21.90625 L 8 19 L 4 19 Z M 24 9 L 24 11 L 28 11 L 28 23 L 24 23 L 24 25.90625 L 20.34375 23 L 12.84375 23 L 10.34375 25 L 19.65625 25 L 26 30.09375 L 26 25 L 30 25 L 30 9 Z'},
    'child': []
  }]
}

export const BsClipboardCheckIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'fill': 'currentColor', 'viewBox': '0 0 16 16'},
  'child': [{
    'tag': 'path',
    'attr': {
      'fillRule': 'evenodd',
      'd': 'M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0'
    },
    'child': []
  }, {
    'tag': 'path',
    'attr': {'d': 'M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z'},
    'child': []
  }, {
    'tag': 'path',
    'attr': {'d': 'M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z'},
    'child': []
  }]
}

export const MdOutlineShowChartIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor'},
  'child': [{'tag': 'path', 'attr': {'fill': 'none', 'd': 'M0 0h24v24H0V0z'}, 'child': []}, {
    'tag': 'path',
    'attr': {'d': 'm3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z'},
    'child': []
  }]
}

export const RiCalendarScheduleLineProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor'},
  'child': [{'tag': 'path', 'attr': {'fill': 'none', 'd': 'M0 0h24v24H0V0z'}, 'child': []}, {
    'tag': 'path',
    'attr': {'d': 'M7 3V1H9V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V9H20V5H17V7H15V5H9V7H7V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7ZM17 12C14.7909 12 13 13.7909 13 16C13 18.2091 14.7909 20 17 20C19.2091 20 21 18.2091 21 16C21 13.7909 19.2091 12 17 12ZM11 16C11 12.6863 13.6863 10 17 10C20.3137 10 23 12.6863 23 16C23 19.3137 20.3137 22 17 22C13.6863 22 11 19.3137 11 16ZM16 13V16.4142L18.2929 18.7071L19.7071 17.2929L18 15.5858V13H16Z'},
    'child': []
  }]
}

export const CuDropdownIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor'},
  'child': [
    {'tag': 'path', 'attr': {'styles': 'color: inherit', 'd': 'M14.05 12.31c1.49 2.05 2.14 2.05 2.45 2.05.31 0 .96 0 2.45-2.05a.995.995 0 0 0-.22-1.4.995.995 0 0 0-1.4.22c-.27.37-.59.75-.83 1.01-.25-.26-.57-.65-.83-1.01a.996.996 0 0 0-1.4-.22c-.44.33-.54.95-.22 1.4Z'}, 'child': []},
    {
      'tag': 'path',
      'attr': {'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'styles': 'color: inherit', 'd': 'M12 19.27c-3.31 0-5.59-.09-6.92-.17-1.52-.09-2.74-1.23-2.89-2.72-.12-1.23-.19-2.66-.19-4.25 0-1.59.06-3.02.19-4.25.15-1.48 1.36-2.63 2.89-2.71C6.4 5.09 8.68 5 12 5s5.6.09 6.92.17c1.52.09 2.74 1.23 2.89 2.72.12 1.24.19 2.67.19 4.25s-.06 3.01-.19 4.25c-.15 1.49-1.37 2.63-2.89 2.72-1.33.08-3.61.17-6.92.17v-.01ZM5.19 7.16c1.163-.063 3.071-.141 5.81-.157v10.254a121.241 121.241 0 0 1-5.81-.157c-.55-.03-.96-.4-1.01-.92-.12-1.16-.18-2.53-.18-4.05s.06-2.89.18-4.05c.05-.52.46-.89 1.01-.92Zm13.62 9.94c-1.16.063-3.07.14-5.794.157V7.003c2.732.016 4.642.094 5.794.157.55.03.96.4 1.01.92.12 1.17.18 2.54.18 4.05 0 1.51-.06 2.88-.18 4.05-.05.52-.46.89-1.01.92Z'},
      'child': []
    }]
}

export const CuTextIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor', color: 'inherit'},
  'child': [
    {
      'tag': 'path',
      'attr': {'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'styles': 'color: inherit', 'd': "M5.5 2.563h13a1.5 1.5 0 0 1 1.5 1.5v1.5a1 1 0 0 1-2 0v-1h-5V19.5h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V4.563H6v1a1 1 0 1 1-2 0v-1.5a1.5 1.5 0 0 1 1.5-1.5Z"},
      'child': []
    }]
}

export const CuNumberIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor', color: 'inherit'},
  'child': [
    {
      'tag': 'path',
      'attr': {'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'styles': 'color: inherit', 'd': "M5.694 20.974a1 1 0 0 1-.772-1.185l.03-.136c.02-.088.048-.218.088-.39.079-.344.2-.857.37-1.536.082-.335.177-.71.285-1.125a94.48 94.48 0 0 1-2.14-.096l-.126-.009a1 1 0 1 1 .143-1.994l.108.007.343.02a77.745 77.745 0 0 0 2.198.087 208.598 208.598 0 0 1 1.49-5.218 106.9 106.9 0 0 0-1.688.071l-.343.02-.107.007a1 1 0 0 1-.145-1.994l.126-.009.36-.02a102.048 102.048 0 0 1 2.415-.095c.207-.663.391-1.236.55-1.721a88.868 88.868 0 0 1 .635-1.876l.047-.13a1 1 0 0 1 1.878.688l-.041.115-.127.36c-.112.322-.278.81-.491 1.464-.103.314-.217.667-.34 1.058a190.012 190.012 0 0 1 5.73.009c.156-.596.289-1.117.4-1.564a85.969 85.969 0 0 0 .445-1.874l.026-.119a1 1 0 0 1 1.957.413l-.03.137-.088.39c-.079.344-.2.857-.37 1.536-.083.336-.178.713-.286 1.13a111.858 111.858 0 0 1 1.861.078l.36.021.126.008a1 1 0 0 1-.143 1.995l-.108-.007-.343-.02a78.037 78.037 0 0 0-2.28-.09 207.691 207.691 0 0 1-1.492 5.224 95.897 95.897 0 0 0 1.772-.074l.343-.02.107-.007a1 1 0 0 1 .145 1.994l-.126.009-.36.02a109.38 109.38 0 0 1-2.498.097 137.56 137.56 0 0 1-.546 1.711 88.536 88.536 0 0 1-.636 1.875l-.047.131a1 1 0 0 1-1.878-.689l.041-.114a86.44 86.44 0 0 0 .618-1.824c.102-.312.215-.661.338-1.049a190.352 190.352 0 0 1-5.73-.011c-.155.592-.287 1.112-.398 1.557a86.908 86.908 0 0 0-.445 1.874l-.026.117a1.01 1.01 0 0 1-1.185.773Zm2.588-6.313a185.321 185.321 0 0 0 5.819-.006 207.267 207.267 0 0 0 1.535-5.317 187.252 187.252 0 0 0-5.82.009 206.913 206.913 0 0 0-1.534 5.314Z"},
      'child': []
    }]
}
export const CuTextareaIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor', color: 'inherit'},
  'child': [
    {
      'tag': 'path',
      'attr': {'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'styles': 'color: inherit', 'd': "M11.32 3.96c.46-.03.8-.35.81-.81v-.29c-.02-.46-.35-.78-.81-.81-.43-.03-.8-.05-1.76-.05s-1.62.02-2.05.05c-.46.03-.8.35-.81.81v.29c.02.46.35.78.81.81.23.02.53.04.9.04-.03 1.14-.07 3.64-.07 7s.04 7.82.07 8.96a25.06 25.06 0 0 0-.66.028L7.51 20c-.46.03-.8.35-.81.81v.33c.02.46.35.78.81.81.43.03 1.09.05 2.05.05.96 0 1.33-.02 1.76-.05.46-.03.8-.35.81-.81v-.33c-.02-.46-.35-.78-.81-.81-.23-.02-.53-.04-.9-.04.03-1.14.07-5.59.07-8.96 0-3.37-.04-5.86-.07-7 .253-.007.473-.018.66-.028l.24-.012ZM12 16.09c0 .55.45 1 1 1l-.01.04c3.419-.01 5.08-.08 6.278-.13h.022c1.32-.06 2.36-.97 2.53-2.22.11-.81.17-1.73.17-2.75s-.06-1.94-.17-2.75c-.17-1.25-1.21-2.16-2.53-2.22-1.2-.06-2.85-.13-6.3-.13-.55 0-1 .45-1 1s.45 1 1 1c3.389 0 5.01.069 6.187.119h.033c.27.01.59.14.64.49.1.72.15 1.55.15 2.47 0 .92-.05 1.75-.15 2.47-.04.34-.37.48-.63.49l-.037.003c-1.187.05-2.818.118-6.183.118-.55 0-1 .45-1 1Zm-6.17.92h.03v-.02c.54 0 .98-.43 1-.97.02-.55-.42-1.01-.97-1.03a38.95 38.95 0 0 1-.735-.026l-.375-.014c-.26-.01-.58-.14-.63-.49-.1-.72-.15-1.55-.15-2.47 0-.92.05-1.75.15-2.47.04-.34.37-.48.63-.49l.375-.015c.222-.009.467-.019.735-.025.55-.02.99-.48.97-1.03-.02-.55-.52-1-1.03-.97-.272.006-.517.016-.74.025l-.39.015c-1.32.06-2.36.97-2.53 2.22C2.06 10.06 2 10.98 2 12s.06 1.94.17 2.75c.17 1.25 1.21 2.17 2.53 2.22l.367.014c.228.01.484.02.763.026Z"},
      'child': []
    }]
}

export const CuCheckboxIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor', color: 'inherit'},
  'child': [
    {
      'tag': 'path',
      'attr': {'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'styles': 'color: inherit', 'd': "M5.92 20.79c1.18.1 3.18.21 6.08.21s4.91-.12 6.08-.21a2.947 2.947 0 0 0 2.71-2.71c.1-1.18.21-3.18.21-6.08s-.12-4.91-.21-6.08a2.947 2.947 0 0 0-2.71-2.71C16.9 3.11 14.9 3 12 3s-4.91.11-6.08.21a2.956 2.956 0 0 0-2.71 2.71C3.11 7.1 3 9.1 3 12s.11 4.91.21 6.08a2.947 2.947 0 0 0 2.71 2.71ZM5.2 6.08a.93.93 0 0 1 .88-.88C7.22 5.11 9.16 5 12 5s4.78.11 5.92.2c.49.04.84.39.88.88.09 1.14.2 3.08.2 5.92s-.11 4.78-.2 5.92a.93.93 0 0 1-.88.88c-1.14.09-3.08.2-5.92.2s-4.78-.11-5.92-.2a.93.93 0 0 1-.88-.88C5.11 16.78 5 14.84 5 12s.11-4.78.2-5.92Zm5.79 9.42H11h-.02.01Zm-.7-.29c.198.188.444.288.7.29a.981.981 0 0 0 .7-.29l4.5-4.5a.996.996 0 1 0-1.41-1.41l-3.79 3.79L9.2 11.3a.996.996 0 1 0-1.41 1.41l2.5 2.5Z"},
      'child': []
    }]
}

export const CuCalendarIconProps: ReactSVGIconProps = {
  'tag': 'svg',
  'attr': {'viewBox': '0 0 24 24', fill: 'currentColor', color: 'inherit'},
  'child': [
    {
      'tag': 'path',
      'attr': {'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'styles': 'color: inherit', 'd': "M7.38 2.041a2.101 2.101 0 0 0-1.336.83c-.271.366-.372.643-.461 1.256l-.021.145-.33.027c-1.048.087-1.9.548-2.448 1.32-.495.698-.575 1.124-.704 3.729-.141 2.873-.054 8.133.163 9.763.166 1.251 1.111 2.311 2.322 2.605 1.193.29 8.654.397 12.81.184 1.862-.096 2.12-.136 2.704-.423.797-.39 1.438-1.182 1.636-2.019.258-1.086.386-6.851.226-10.11-.127-2.574-.217-3.047-.7-3.723-.556-.781-1.403-1.239-2.453-1.326l-.329-.027-.021-.145c-.09-.613-.19-.89-.461-1.256-.349-.472-.803-.74-1.413-.836-.41-.064-1.183-.023-1.514.081-.734.231-1.323.915-1.453 1.689l-.05.297h-3.073l-.05-.297c-.13-.774-.717-1.456-1.454-1.69-.301-.095-1.231-.138-1.59-.074Zm1.048 2.057c.054.082.06.234.05 1.04-.007.657-.025.956-.058.99-.028.027-.18.047-.372.05-.482.002-.46.051-.475-1.059-.016-1.156-.031-1.117.453-1.117.313 0 .343.007.402.096Zm7.969.001c.054.083.062.23.05 1.02-.015 1.11.008 1.061-.475 1.058-.192-.002-.343-.022-.371-.05-.033-.033-.051-.332-.059-.99-.015-1.178-.032-1.135.452-1.135.315 0 .344.007.403.097Zm3.558 5.41c.097 2.442.084 6.05-.077 8.387-.034.474-.072.93-.086 1.013-.06.365-.437.77-.809.867-.16.043-.994.102-2.328.166-1.42.067-6.136.092-7.868.04-2.737-.08-3.675-.146-3.936-.28-.412-.21-.585-.485-.647-1.03-.204-1.8-.258-6.102-.132-9.172 1.92 0 13.928.009 15.883.009Z"},
      'child': []
    }]
}

export const GenerateTextSparkIconProps: ReactSVGIconProps = {
  tag: 'svg',
  attr: {
    fill: '#fff',
    viewBox: '0 0 128 128',
  },
  child: [
    {
      tag: 'path',
      attr: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-width': '7',
        d: 'M112 31H16M66 64H16M66 97H16'
      },
      child: []
    },
    {
      tag: 'path',
      attr: {
        fill: 'currentColor',
        d: 'M76 96C76 98.2091 77.7909 100 80 100C82.2091 100 84 98.2091 84 96C84 93.7909 82.2091 92 80 92C77.7909 92 76 93.7909 76 96Z'
      },
      child: []
    },
    {
      tag: 'path',
      attr: {
        stroke: 'currentColor',
        'stroke-linejoin': 'round',
        'stroke-width': '7',
        d: 'M96.207 67.6284C96.9409 66.1432 99.0591 66.1432 99.793 67.6284L100.786 69.6371C102.47 73.046 104.91 76.0257 107.92 78.3495L109.95 79.917C110.987 80.7176 110.987 82.2824 109.95 83.083L107.92 84.6505C104.91 86.9743 102.47 89.954 100.786 93.3629L99.793 95.3716C99.0591 96.8568 96.9409 96.8568 96.207 95.3716L95.2144 93.3629C93.5299 89.954 91.0899 86.9743 88.0803 84.6505L86.0502 83.083C85.0133 82.2824 85.0133 80.7176 86.0502 79.917L88.0803 78.3495C91.0899 76.0257 93.5299 73.046 95.2144 69.6371L96.207 67.6284Z'
      },
      child: []
    }
  ]
};


export const SparkOneIconProps: ReactSVGIconProps = {
  tag: 'svg',
  attr: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 100 100',
    fill: 'none',
  },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M62.7737 54C66.9643 56.5233 70.4767 60.0356 72.9999 64.2262C75.5231 60.0356 79.0355 56.5233 83.2261 54C79.0355 51.4768 75.5231 47.9645 72.9999 43.7738C70.4767 47.9645 66.9643 51.4768 62.7737 54ZM54.6034 51.1865C51.9916 52.1529 51.9916 55.8471 54.6034 56.8136L55.6278 57.1926C62.197 59.6235 67.3765 64.8029 69.8073 71.3722L70.1864 72.3965C71.1528 75.0084 74.847 75.0084 75.8135 72.3965L76.1925 71.3722C78.6233 64.8029 83.8028 59.6235 90.3721 57.1926L91.3964 56.8136C94.0082 55.8471 94.0082 52.1529 91.3964 51.1865L90.3721 50.8074C83.8028 48.3766 78.6233 43.1971 76.1925 36.6279L75.8135 35.6035C74.847 32.9917 71.1528 32.9917 70.1864 35.6035L69.8073 36.6279C67.3765 43.1971 62.197 48.3766 55.6278 50.8074L54.6034 51.1865Z',
        fill: 'currentColor',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M18.0693 32C24.6898 35.0021 29.9979 40.3101 32.9999 46.9306C36.0019 40.3101 41.31 35.0021 47.9305 32C41.31 28.998 36.0019 23.6899 32.9999 17.0695C29.9979 23.6899 24.6898 28.998 18.0693 32ZM8.60342 29.1865C5.99157 30.1529 5.99157 33.8471 8.60342 34.8136L14.0072 36.8132C20.5765 39.244 25.7559 44.4235 28.1868 50.9927L30.1864 56.3965C31.1528 59.0084 34.847 59.0084 35.8135 56.3965L37.813 50.9927C40.2439 44.4235 45.4233 39.244 51.9926 36.8132L57.3964 34.8136C60.0082 33.8471 60.0083 30.1529 57.3964 29.1865L51.9926 27.1869C45.4234 24.756 40.2439 19.5766 37.813 13.0073L35.8135 7.60355C34.847 4.99169 31.1528 4.99169 30.1864 7.60354L28.1868 13.0073C25.7559 19.5766 20.5765 24.756 14.0072 27.1869L8.60342 29.1865Z',
        fill: 'currentColor',
        fillRule: 'evenodd',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M48.2785 89.5811C48.2409 89.6535 48.2036 89.7261 48.1668 89.799C47.8378 90.4512 47.544 91.1249 47.2877 91.8175C46.5018 93.9412 43.498 93.9412 42.7122 91.8175C42.4559 91.1249 42.162 90.4512 41.833 89.799C41.7962 89.7261 41.759 89.6535 41.7213 89.5811L41.7195 89.5776C39.8711 86.0271 36.9729 83.1289 33.4223 81.2805L33.4188 81.2786C33.3465 81.241 33.2738 81.2038 33.2009 81.167C32.5487 80.8379 31.8751 80.5441 31.1825 80.2878C29.0587 79.5019 29.0587 76.4981 31.1825 75.7123C31.8751 75.456 32.5487 75.1621 33.2009 74.8331C33.2738 74.7963 33.3465 74.7591 33.4188 74.7214L33.4223 74.7196C36.9729 72.8712 39.8711 69.973 41.7195 66.4225L41.7213 66.419C41.759 66.3466 41.7962 66.2739 41.833 66.201C42.162 65.5488 42.4559 64.8752 42.7122 64.1826C43.498 62.0588 46.5018 62.0588 47.2877 64.1826C47.544 64.8752 47.8378 65.5488 48.1668 66.201C48.2036 66.2739 48.2409 66.3466 48.2785 66.4189L48.2803 66.4225C50.1288 69.973 53.027 72.8712 56.5775 74.7196L56.581 74.7214C56.6534 74.7591 56.726 74.7963 56.7989 74.8331C57.4511 75.1621 58.1247 75.456 58.8173 75.7123C60.9411 76.4981 60.9411 79.5019 58.8173 80.2878C58.1247 80.5441 57.4511 80.8379 56.7989 81.167C56.726 81.2038 56.6534 81.241 56.581 81.2786L56.5775 81.2805C53.027 83.1289 50.1288 86.0271 48.2803 89.5776L48.2785 89.5811ZM44.9999 83.5208C46.546 81.4086 48.4085 79.5461 50.5207 78C48.4085 76.454 46.546 74.5915 44.9999 72.4792C43.4539 74.5915 41.5914 76.454 39.4791 78C41.5914 79.5461 43.4539 81.4086 44.9999 83.5208Z',
        fill: 'currentColor',
        fillRule: 'evenodd',
      },
      child: []
    }
  ]
};

// antd's `EuroOutlined` glyph with its enclosing circle cropped out.
export const EuroSymbolIconProps: ReactSVGIconProps = {
  tag: 'svg',
  attr: { viewBox: '258 282 460 460', fill: 'currentColor', width: '1em', height: '1em' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M629.7 295.4c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z',
      },
      child: [],
    },
  ],
};
